export default __webpack_public_path__ + "static/sun-4be4672028681d1984d5b921287b8b6a.svg";